(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/receipt/constants.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/receipt/constants.js');

const TEXTS = {
  DIGITAL_RECEIPT: 'DIGITAL',
  PHYSICAL_RECEIPT: 'PHYSICAL',
  HEADER: 'Tack för din beställning!',
  BUTTON_LABEL: 'Ny beställning',
  ORDERED_PRODUCTS: 'Du har beställt följande produkter:',
  DIGITAL: {
    MY_ORDERS_TEXT: 'Du hittar din beställning under ',
    MY_ORDERS_LINK_TEXT: 'Mina beställningar',
    NEW_ORDER_TEXT: 'Ny beställning',
    PASSWORD_SENT: 'Lösenord till tjänstens inloggning skickas till företagets registrerade adress efter genomförd kreditupplysning. Mer information finner du längre ner på sidan.'
  },
  PHYSICAL: {
    INFO: 'En bekräftelse skickas till din angivna e-postadress när din order är behandlad.'
  }
};

svs.ticket_partner.sharedComponents.receipt.constants = {
  TEXTS
};


 })(window);